import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons

import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import StarHalfIcon from "@material-ui/icons/StarHalf";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.js";

import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Small from "components/Typography/Small.js";
import Danger from "components/Typography/Danger.js";
import Warning from "components/Typography/Warning.js";
import Success from "components/Typography/Success.js";
import Info from "components/Typography/Info.js";
import Primary from "components/Typography/Primary.js";
import Muted from "components/Typography/Muted.js";
import Quote from "components/Typography/Quote.js";
import SectionContact from "views/Main/SectionContact";

import typographyStyle from "assets/jss/material-kit-pro-react/views/componentsSections/typographyStyle.js";

import image from "assets/img/faces/avatar.jpg";

const useStyles = makeStyles(typographyStyle);

export default function RateAndReview() {
  const [rating, setRating] = React.useState(3.5); // Default rating is 3
  const classes = useStyles();

  const responseValue = 86;
  const qualityValue = 100;
  const deliveryValue = 98;

  return (
    // <div className={classes.section}>
      <div className={classes.container}>
        <div id="review" className="cd-section">
          <div className={classes.title}>
            <h2>Ratings & Reviews</h2>
          </div>
          <GridContainer>
            <GridItem md={4}>
              <span style={{ whiteSpace: "nowrap" }}>
                <p style={{ display: "inline", margin: 0, fontSize: 20 }}>
                  4.5
                </p>
                /<p style={{ display: "inline", margin: 0 }}>5</p>
              </span>
              <br />
              <span>
                {[...Array(5)].map((_, index) => {
                  if (index < Math.floor(rating)) {
                    // Full star for indices less than the integer part of the rating
                    return (
                      <StarIcon
                        key={index}
                        fontSize="large"
                        style={{ color: "red", fontSize: "20px" }}
                        onClick={() => setRating(index + 1)} // Update to a full star on click
                      />
                    );
                  } else if (index < rating) {
                    // Half star for the fractional part
                    return (
                      <StarHalfIcon
                        key={index}
                        fontSize="large"
                        style={{ color: "red", fontSize: "20px" }}
                        onClick={() => setRating(index + 1)} // Treat click as a full star
                      />
                    );
                  } else {
                    // Empty star for the rest
                    return (
                      <StarBorderIcon
                        key={index}
                        fontSize="large"
                        style={{ color: "red", fontSize: "20px" }}
                        onClick={() => setRating(index + 1)} // Update to a full star on click
                      />
                    );
                  }
                })}
              </span>
              <br />
              <span>
                Reviewed by 35 Users
                <br />
                Last Reviewed on 25 November, 2024
              </span>
            </GridItem>
            <GridItem md={4}>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%", // Ensures the container spans the full width
                }}
              >
                <p
                  style={{
                    margin: 0,
                    fontSize: "15px",
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "nowrap", // Prevents text wrapping
                  }}
                >
                  5{" "}
                  <StarBorderIcon
                    style={{ fontSize: "15px", marginLeft: "4px" }}
                  />
                </p>
                <CustomLinearProgress
                  style={{
                    flexGrow: 1, // Makes the progress bar stretch to fill the remaining space
                    margin: "0 8px", // Adds spacing between the progress bar and other elements
                  }}
                  variant="determinate"
                  color="primary"
                  value={30}
                />
                <span style={{ whiteSpace: "nowrap" }}>30%</span>
              </span>

              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%", // Ensures the container spans the full width
                }}
              >
                <p
                  style={{
                    margin: 0,
                    fontSize: "15px",
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "nowrap", // Prevents text wrapping
                  }}
                >
                  4{" "}
                  <StarBorderIcon
                    style={{ fontSize: "15px", marginLeft: "4px" }}
                  />
                </p>
                <CustomLinearProgress
                  style={{
                    flexGrow: 1, // Makes the progress bar stretch to fill the remaining space
                    margin: "0 8px", // Adds spacing between the progress bar and other elements
                  }}
                  variant="determinate"
                  color="primary"
                  value={40}
                />
                <span style={{ whiteSpace: "nowrap" }}>40%</span>
              </span>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%", // Ensures the container spans the full width
                }}
              >
                <p
                  style={{
                    margin: 0,
                    fontSize: "15px",
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "nowrap", // Prevents text wrapping
                  }}
                >
                  3{" "}
                  <StarBorderIcon
                    style={{ fontSize: "15px", marginLeft: "4px" }}
                  />
                </p>
                <CustomLinearProgress
                  style={{
                    flexGrow: 1, // Makes the progress bar stretch to fill the remaining space
                    margin: "0 8px", // Adds spacing between the progress bar and other elements
                  }}
                  variant="determinate"
                  color="primary"
                  value={50}
                />
                <span style={{ whiteSpace: "nowrap" }}>50%</span>
              </span>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%", // Ensures the container spans the full width
                }}
              >
                <p
                  style={{
                    margin: 0,
                    fontSize: "15px",
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "nowrap", // Prevents text wrapping
                  }}
                >
                  2{" "}
                  <StarBorderIcon
                    style={{ fontSize: "15px", marginLeft: "4px" }}
                  />
                </p>
                <CustomLinearProgress
                  style={{
                    flexGrow: 1, // Makes the progress bar stretch to fill the remaining space
                    margin: "0 8px", // Adds spacing between the progress bar and other elements
                  }}
                  variant="determinate"
                  color="primary"
                  value={60}
                />
                <span style={{ whiteSpace: "nowrap" }}>60%</span>
              </span>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%", // Ensures the container spans the full width
                }}
              >
                <p
                  style={{
                    margin: 0,
                    fontSize: "15px",
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "nowrap", // Prevents text wrapping
                  }}
                >
                  1{" "}
                  <StarBorderIcon
                    style={{ fontSize: "15px", marginLeft: "4px" }}
                  />
                </p>
                <CustomLinearProgress
                  style={{
                    flexGrow: 1, // Makes the progress bar stretch to fill the remaining space
                    margin: "0 8px", // Adds spacing between the progress bar and other elements
                  }}
                  variant="determinate"
                  color="primary"
                  value={80}
                />
                <span style={{ whiteSpace: "nowrap" }}>80%</span>
              </span>
            </GridItem>
            <GridItem md={4}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ width: 100, height: 100 }}>
                  <CircularProgressbarWithChildren value={responseValue}>
                    <div
                      style={{
                        fontSize: 12,
                        marginTop: -5,
                        textAlign: "center",
                      }}
                    >
                      <strong>86%</strong> <br />
                      Response
                    </div>
                  </CircularProgressbarWithChildren>
                </div>
                <div style={{ width: 100, height: 100 }}>
                  <CircularProgressbarWithChildren value={qualityValue}>
                    <div
                      style={{
                        fontSize: 12,
                        marginTop: -5,
                        textAlign: "center",
                      }}
                    >
                      <strong>100%</strong> <br />
                      Quality
                    </div>
                  </CircularProgressbarWithChildren>
                </div>
                <div style={{ width: 100, height: 100 }}>
                  <CircularProgressbarWithChildren value={deliveryValue}>
                    <div
                      style={{
                        fontSize: 12,
                        marginTop: -5,
                        textAlign: "center",
                      }}
                    >
                      <strong>99%</strong> <br />
                      Delivery
                    </div>
                  </CircularProgressbarWithChildren>
                </div>
              </div>
            </GridItem>
          </GridContainer>
          <hr />
        </div>
        <div className={classes.space50} />
        <SectionContact />
      </div>
  );
}
